import { Input, Select } from 'Components';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { useUserContext } from 'Pages/User/UserContext';
import Layout from './Layout';

const GeneralInfo = ({
	isProfile,
	isAddNewUser,
	openModal
}: {
	isProfile: boolean;
	isAddNewUser: boolean;
	openModal: () => void;
}) => {
	const { t } = useTranslation();
	const { timezones, timezonesList } = useUserContext();
	const { isValid, dirty, setFieldTouched } = useFormikContext();
	const disabled = !(isValid && dirty);

    return <Layout title={t(`profile.general.title`)} description={t(`profile.general.description`)} btnText={isProfile ? t(`saveChanges`) : ''} handleNext={openModal} btnDisable={disabled}>
        <Input.FormikField
            name="firstName"
            label={t('phishingManager.report.overallResultsCard.fields.name')}
            placeholder={t('profile.general.placeholders.name')}
            required
        />
        <Input.FormikField
            name="lastName"
            label={t('user.lastName')}
            placeholder={t('profile.general.placeholders.lastName')}
            required
        />
        <Input.FormikField
            name="email"
            label={t('user.email')}
            placeholder={t('profile.general.placeholders.email')}
            required
        />
        <Input.FormikField
            name="cognitoLogin"
            label={t('user.userName')}
            placeholder={t('profile.general.placeholders.userName')}
            disabled={!isAddNewUser}
            required
        />
        <Input.FormikField
            name="phoneNumber"
            label={t('user.phoneNumber')}
            placeholder={t('profile.general.placeholders.phoneNumber')}
            onChange={() => setFieldTouched("phoneNumber", true)}
        />
        <Select.FormikField 
            name="timezoneId"
            placeholder={t('profile.general.placeholders.timeZone')}
            label={t('user.timezoneId')} loading={timezones.loading}>
            {timezonesList?.map((option) => (
                <Select.Option key={option.id} value={option.id}>
                    {option.zone}
                </Select.Option>
            ))}
        </Select.FormikField>
    </Layout>
}

export default GeneralInfo;
